import React, { useEffect, useState } from 'react';
import { Modal, Card, Row, Col, Accordion } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { isEmpty, set, cloneDeep, concat, get } from 'lodash';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

import {
  columTypeList,
  productCpAttributeList,
  productCpoutComeList,
  poProductoutComeList,
  ColumnValues,
  customStylesForOCP,
  PCPLocation,
  PCPSublocationList,
  isExactMatch,
  filterCustomAttributesDropdownAndTextType,
  customSectionPlacementArry,
  prouctCustmSectionOutComeList,
  prouctBomOutComeList,
  manualLabelColours,
  manualStatusColours,
  productCpmanualTypeList,
  RightsAccess,
} from '../../../Components/helper';
import * as userAction from '../../UserSetting/store/User.action';
import * as customAction from '../../RangePlan/CustomSections/store/CustomSections.action';
import * as action from '../store/ProductCP.action';
import { commonPath, sourcePath } from '../fieldPath';
import * as systemMasterAction from '../../SystemMasters/Store/SystemMasters.action';
import * as devOrderAction from '../../DevlopmentOrder/store/DevelopmentOrder.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import ManualColumnSection from './ManualColumnSection';
import SourceColumnSection from './SourceColumnSection';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import DependentAccordian from './DependentAccoridian';
import CustomNotification from './CustomNotification';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import NewCommonMultiSelect from '../../../Components/Utility/FilterAction/NewCommonMultiSelect';
import DurationCounter from './DurationCounter';

/**
 * Whether a column's value is a date, making it eligible for the dependent /
 * duration / notification options. Covers manual date-pickers and every
 * date-valued source column: sub-location date fields plus the date-yielding
 * outputs (`date_added`, `status_date`). Centralised so a new date output is
 * gated in one place instead of across the five render/init conditions.
 *
 * @param {Object} col - Column or card element carrying source/manualType config.
 * @returns {boolean}
 */
const isDateValueColumn = (col) =>
  col?.manualType?.key === 'Date_picker' ||
  col?.source?.subLocation?.type === 'date' ||
  col?.source?.output?.name === 'date_added' ||
  col?.source?.output?.name === 'status_date';

function AddEditColumn({ parentData, handleClose, selectedTab, colEditData }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { id } = useParams();
  const {
    Users: { userGroupsCardList },
    SystemMastersDetails: {
      customAttributeDetail,
      mainSampleList,
      otherSamplesList,
      sampleTypeGroupList,
      placement_master,
      measurement_master,
      subBrandAccess,
      bomSourceCustomAttribute,
    },
    UserDetails: { userInfo },
    Users: { logInRights },
    customSectionData: { bomTypes, sampleTrackingDates, customColumnList },
    ProductCPReducer: { supplierList, productCpTabs },
  } = useSelector((reducer) => reducer);
  const { CheckActionPermission } = useComponent();
  const addEditAccess = CheckActionPermission(logInRights, 'criticalPath', 'product', 'addEdit');
  const loggedInUserId = userInfo?.userId;
  const thisFieldIsRequired = 'This field is required';
  const careUserDocumentInformation = 'Care/User_Document_Information';
  const getSelectedTabData = productCpTabs?.find((data) => data?._id === selectedTab?._id);
  const { rangePlanRight, TestingRight } = RightsAccess();
  const [statusChaning, setStatusChaning] = useState(false);
  const [modalState, setModalState] = useState({
    cards: [
      {
        name: '',
        isVisibleToSupplier: false,
        assignee: [],
        isEditableAssignee: false,
        columnType: null,
        source: {
          location: null,
          output: null,
          subLocation: null,
          locationType: null,
          locationPlacement: null,
          attribute: null,
        },
        colorSwitch: false,
        CustomNotificationSwitch: false,
        customDurations: [{ durationUnit: null, durationValue: null, emailNotification: false }],
        dependentObj: {
          dependentSwitch: false,
          durationUnit: null,
          durationValue: null,
          dependentColumn: null,
          futureDependent: false,
        },

        durationCounterSwitch: false,
        durationlinkedColumnValue: null,

        hasError: false,
        manualType: null,
        filterObj: {},
        colourCoding: {},
        isRequired: false,
        colourArray: [
          {
            colourValue: '',
            colourType: 'green',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'amber',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'red',
            startPercentage: '',
            endPercentage: '',
          },
        ],
        options: [{ name: '' }],
        labelColoursOptions: manualLabelColours,
        status: null,
        pom: null,
        displayFormat: null,
        statusColoursOptions: manualStatusColours,
        isStatusEditTrue: false,
        characterLimit: '',
        objId: '',
        tabSequence: selectedTab?.sequence || getSelectedTabData?.sequence,
      },
    ],
    asigneeList: [],
    loading: false,
    dyanmicColumns: [],
    manualCustomColumns: [],
    sampleType: [],
    dateTypeColumn: [],
  });
  const [locationOptions, setLocationOptions] = useState(PCPLocation?.filter((ele) => ele?.name !== 'custom_module'));

  useEffect(() => {
    if (!TestingRight) {
      const filterList = PCPLocation.filter((res) => res.name !== 'Testing');
      setLocationOptions(filterList);
    }
  }, [TestingRight]);

  useEffect(() => {
    if (!isEmpty(userGroupsCardList)) {
      setModalState((oldState) => ({
        ...oldState,
        asigneeList: [...userGroupsCardList],
      }));
    }
  }, [userGroupsCardList]);

  useEffect(() => {
    const otherSampleOptions = (otherSamplesList ?? [])
      .filter((el) => el?.isActive === true && el?.isDeleted === false)
      .map((el) => ({ label: el?.name, name: el?._id }));
    setModalState((prevState) => ({
      ...prevState,
      sampleType: otherSampleOptions,
    }));
  }, [otherSamplesList]);

  useEffect(() => {
    if (colEditData && parentData) {
      if (parseInt(colEditData?.source?.location?._id, 10) === 12) {
        const callManualColumns = async () => {
          setModalState((oldState) => ({ ...oldState, loading: true }));
          const res = await dispatch(customAction.fetchCustomColumnList(colEditData?.source?.location?.name));
          res && setModalState((oldState) => ({ ...oldState, loading: false }));
        };
        callManualColumns();
      }
      if (parseInt(colEditData?.source?.location?._id, 10) === 4) {
        const callEcomApi = async () => {
          const ecomValues = await dispatch(devOrderAction.getEcommSpec('eCommSpec'));
          if (ecomValues?.isActive) {
            await dispatch(systemMasterAction.getMeasurementDetails({ isActive: true }));
          }
        };
        callEcomApi();
      }
      const cards = [
        {
          ...colEditData,
          name: colEditData?.name,
          isPinned: colEditData?.isPinned || false,
          isEditableAssignee: colEditData?.isEditableAssignee || false,
          source: {
            location: {
              name: colEditData?.source?.location?.name,
              label: colEditData?.source?.location?.label,
              _id: parseInt(colEditData?.source?.location?._id),
            },
            sampleGroupId: colEditData?.source?.sampleGroupId
              ? { name: colEditData.source.sampleGroupId.name, label: colEditData.source.sampleGroupId.label }
              : null,
            output: {
              name: colEditData?.source?.output?.name,
              label: colEditData?.source?.output?.label,
            },
            subLocation: {
              name: colEditData?.source?.subLocation?.name,
              label: colEditData?.source?.subLocation?.label,
              type: colEditData?.source?.subLocation?.type,
            },
            locationType: {
              name: colEditData?.source?.locationType?.name,
              label: colEditData?.source?.locationType?.label,
            },
            locationPlacement: {
              name: colEditData?.source?.locationPlacement?.name,
              label: colEditData?.source?.locationPlacement?.label,
            },
            attribute: {
              name: colEditData?.source?.attribute?.name,
              label: colEditData?.source?.attribute?.label,
            },
            pom: {
              name: colEditData?.source?.pom?.name,
              label: colEditData?.source?.pom?.label,
            },
            displayFormat: {
              name: colEditData?.source?.displayFormat?.name,
              label: colEditData?.source?.displayFormat?.label,
            },
          },
          nameCount: colEditData?.name?.length,
          hasError: false,
          sequence: colEditData?.sequence,
          tabSequence: colEditData?.tabSequence || selectedTab?.sequence || getSelectedTabData?.sequence,
          columnType: columTypeList?.find((element) => element?._id === colEditData?.columnType),
          manualType: productCpmanualTypeList.find((pcm) => pcm?.key === colEditData?.manualType?.key),
          dependentObj:
            isDateValueColumn(colEditData)
              ? { ...colEditData?.dependentObj, dependentSwitch: colEditData?.dependentObj?.durationUnit !== null }
              : null,
          customDurations: colEditData?.customDurations,
          objId: colEditData?._id,
          CustomNotificationSwitch: colEditData?.CustomNotificationSwitch,
          colorSwitch: colEditData?.isColourCodingActive,
          options: colEditData?.options || [{ name: '' }],
          labelColoursOptions: colEditData?.labelColoursOptions || manualLabelColours,
          status: colEditData?.status || null,
          statusColoursOptions: colEditData?.statusColoursOptions || manualStatusColours,
          characterLimit: colEditData?.characterLimit,
          colourArray: isEmpty(colEditData?.colourCoding)
            ? [
                {
                  colourValue: '',
                  colourType: 'green',
                  startPercentage: '',
                  endPercentage: '',
                },
                {
                  colourValue: '',
                  colourType: 'amber',
                  startPercentage: '',
                  endPercentage: '',
                },
                {
                  colourValue: '',
                  colourType: 'red',
                  startPercentage: '',
                  endPercentage: '',
                },
              ]
            : [...(colEditData?.colourCoding || [])],
        },
      ];
      setModalState((previousData) => ({
        ...previousData,
        cards: [...cards],
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colEditData, parentData]);

  useEffect(() => {
    const columns = [];
    parentData?.Tabs?.forEach((tab) => {
      if (Array.isArray(tab?.columns)) {
        columns.push(...tab.columns);
      }
    });
    const clonedColumns = cloneDeep(columns);
    const relativeColumns = clonedColumns?.filter((col) => {
      if (col?._id !== modalState?.cards[0]?.objId && col?.dependentObj?.dependentColumn?._id !== modalState?.cards[0]?.objId) return col;
    });
    const allDateColumns = relativeColumns
      ?.filter((colEle) => isDateValueColumn(colEle))
      ?.map((e) => ({ name: e?.name, _id: e?._id }));
    const manualColumns = columns?.filter(
      (colEle) => colEle.columnType === 'manual' && colEle.manualType?.key === 'Date_picker' && colEle?._id !== colEditData?._id,
    );
    setModalState((oldState) => ({
      ...oldState,
      dyanmicColumns: manualColumns,
      dateTypeColumn: cloneDeep(allDateColumns),
    }));
  }, [selectedTab, modalState?.cards, parentData?.Tabs, parentData?.tabId]);

  useEffect(() => {
    const callFn = async () => {
      setModalState((oldState) => ({
        ...oldState,
        loading: true,
      }));
      if (rangePlanRight) {
        await dispatch(customAction.fetchAllSections());
      }
      await Promise.all([
        dispatch(customAction.fetchCustomSectionBomTypeAction({ isAllRecord: true })),
        dispatch(systemMasterAction.getMainSampleDetails({ loggedInUserId })),
        dispatch(systemMasterAction.getOtherSamplesDetails({ loggedInUserId })),
        dispatch(systemMasterAction.getPlacementDetails({ loggedInUserId, isActive: true })),
        dispatch(systemMasterAction.getSampleTypeGroupDetails({ isActive: true })),
      ]);

      setModalState((oldState) => ({
        ...oldState,
        loading: false,
      }));
    };
    if (!isEmpty(loggedInUserId)) callFn();
  }, [loggedInUserId, dispatch]);

  useEffect(() => {
    const initialCall = async () => {
      setModalState((oldState) => ({
        ...oldState,
        loading: true,
      }));

      await Promise.all([
        dispatch(userAction.fetchUserGroupsCards({ fromPCP: id })),
        dispatch(systemMasterAction.getCustomAttributeDetail({ isActive: true })),
        dispatch(customAction.getAllMeasurment()),
        dispatch(customAction.getSampleTrackingDates()),
      ]);

      setModalState((oldState) => ({
        ...oldState,
        loading: false,
      }));
    };
    initialCall();
  }, [dispatch]);

  const addCard = async () => {
    const updatedCardArray = [...modalState.cards];
    const validated = await checkValidation(updatedCardArray);
    if (!validated) {
      updatedCardArray.push({
        name: '',
        isVisibleToSupplier: false,
        assignee: [],
        isEditableAssignee: false,
        columnType: null,
        source: {
          location: null,
          output: null,
          subLocation: null,
          locationType: null,
          locationPlacement: null,
          attribute: null,
        },
        colorSwitch: false,
        CustomNotificationSwitch: false,
        dependentObj: {
          durationUnit: null,
          durationValue: null,
          dependentColumn: null,
          futureDependent: false,
          dependentSwitch: false,
        },
        durationCounterSwitch: false,
        durationlinkedColumnValue: null,
        hasError: false,
        manualType: null,
        filterObj: {},
        colourCoding: {},
        isRequired: false,
        customDurations: [{ durationUnit: null, durationValue: null, emailNotification: false }],
        colourArray: [
          {
            colourValue: '',
            colourType: 'green',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'amber',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'red',
            startPercentage: '',
            endPercentage: '',
          },
        ],
        options: [{ name: '' }],
        labelColoursOptions: manualLabelColours,
        status: null,
        pom: null,
        displayFormat: null,
        statusColoursOptions: manualStatusColours,
        isStatusEditTrue: false,
        characterLimit: '',
        tabSequence: selectedTab?.sequence || getSelectedTabData?.sequence,
      });
      setModalState((oldState) => ({ ...oldState, cards: updatedCardArray }));
    }
  };

  useEffect(() => {
    if (customColumnList) {
      const manualColumns = [];
      manualColumns.push(...(customColumnList?.columns ?? []).filter((colmElement) => colmElement?.columnType === 'manual'));
      setModalState((previousState) => ({
        ...previousState,
        manualCustomColumns: manualColumns,
        loading: false,
      }));
    }
  }, [customColumnList]);

  const chcekingFromDynamicArray = (array, mainObj) => {
    return typeof mainObj === 'object' ? array?.find((ele) => ele?._id === mainObj?._id || mainObj?.value) : array?.find((ele) => ele?._id === mainObj);
  };

  const deleteCard = (index) => {
    const updatedCards = [...modalState.cards];
    updatedCards.splice(index, 1);
    setModalState((oldState) => ({ ...oldState, cards: updatedCards }));
  };

  const forSwitch = (e, i) => {
    const cards = [...modalState.cards];
    cards[i].colorSwitch = e?.target?.checked;
    if (!e?.target?.checked) {
      cards[i].colourArray = [
        {
          colourValue: '',
          colourType: 'green',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'amber',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'red',
          startPercentage: '',
          endPercentage: '',
        },
      ];
    }
    setModalState((oldState) => ({
      ...oldState,
      cards: [...cards],
    }));
  };

  const onChangeDropDown = (e, name, index, i) => {
    const cardsArray = [...modalState.cards];
    switch (name) {
      case 'Brand':
        cardsArray[index].filterObj.brand = e;
        setModalState((otherState) => ({
          ...otherState,
          cards: cardsArray,
        }));
        break;
      case 'Season':
        cardsArray[index].filterObj.season = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Year':
        cardsArray[index].filterObj.year = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Category 1':
        cardsArray[index].filterObj.category_1 = [...e];
        cardsArray[index].filterObj.category_3 = [];
        cardsArray[index].filterObj.category_4 = [];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Category 2':
        cardsArray[index].filterObj.category_2 = [...e];
        cardsArray[index].filterObj.category_3 = [];
        cardsArray[index].filterObj.category_4 = [];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Category 3':
        cardsArray[index].filterObj.category_3 = [...e];
        cardsArray[index].filterObj.category_4 = [];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Category 4':
        cardsArray[index].filterObj.category_4 = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Product Type':
        cardsArray[index].filterObj.product_Type = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Month':
        cardsArray[index].filterObj.month = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'colourValue':
        cardsArray[index].colourArray[i].colourValue = e?._id;
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;

      default:
        cardsArray[index].filterObj.suppliers = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
    }
  };

  const changeColourInput = (value, name, index, i) => {
    const colourValues = [...modalState.cards];
    colourValues[index].colourArray[i][name] = value;
    setModalState((previousStates) => ({
      ...previousStates,
      colourValue: [...colourValues],
    }));
  };

  const constantTextValue = (i) => {
    if (i === 0) {
      return 'if before the time frame of ';
    }
    if (i === 1) {
      return 'if within time frame';
    }
    return 'if exceeds time frame of ';
  };
  const ifPropNotExist = (ele, property) => {
    if (!ele?.[property]?.name) {
      delete ele?.[property];
    }
  };

  const addUpdateColumn = async () => {
    setModalState((oldState) => ({ ...oldState, loading: true }));
    const updatedarr = cloneDeep(modalState?.cards) || [];
    const hasNonUniqueNames = updatedarr.some((item, index) => updatedarr.filter((el, i) => el.name === item.name && index !== i).length > 0);

    if (!hasNonUniqueNames) {
      const updatedArray = updatedarr?.map((ele, i) => {
        delete ele?.hasError;
        delete ele?.nameCount;
        ele.name = ele?.name?.trim();
        ele.source = {
          ...ele.source,
          attribute: {
            label: ele?.source?.attribute?.label,
            name: ele?.source?.attribute?.name,
          },
          output: {
            label: ele?.source?.output?.label,
            name: ele?.source?.output?.name,
          },
        };
        delete ele.attribute;
        delete ele.output;
        ele.isColourCodingActive = ele?.colorSwitch;
        ele.colourCoding = ele?.colourArray;

        delete ele?.colourArray;
        delete ele?.colorSwitch;
        if (ele?.dependentObj?.dependentColumn?._id) {
          ele.dependentColumnId = ele?.dependentObj?.dependentColumn?._id;
        }
        if (ele?.columnType?._id === 'manual') {
          delete ele?.source;
          savingForManualItem(ele);
        }

        if (ele?.columnType?._id === 'source') {
          delete ele?.status;
          delete ele?.characterLimit;
          delete ele?.labelColoursOptions;
          delete ele?.options;
          delete ele?.statusColoursOptions;
          if (!ele?.pom) {
            delete ele?.pom;
          }
          if (!ele?.displayFormat) {
            delete ele?.displayFormat;
          }
        }
        if (!('sequence' in ele)) {
          ele.sequence = forColumnSequence(i);
        }
        ele.productCPId = parentData?._id;
        ele.tabId = selectedTab?._id || parentData?.tabId;
        ele.assignee = ele?.assignee || [];
        // Add tabSequence to column if it exists
        if (selectedTab?.sequence !== undefined) {
          ele.tabSequence = selectedTab.sequence;
        } else if (getSelectedTabData?.sequence !== undefined) {
          ele.tabSequence = getSelectedTabData.sequence;
        }
        ifPropNotExist(ele, 'source?.subLocation');
        ifPropNotExist(ele, 'source?.locationPlacement');
        ifPropNotExist(ele, 'source?.locationType');
        ifPropNotExist(ele, 'stabId');
        if (!ele?.manualType) {
          delete ele?.manualType;
        }
        return ele;
      });
      const insertObj = {
        columns: [...updatedArray],
      };
      if (updatedarr?.[0]?._id) {
        insertObj.productCPId = parentData?._id;
        insertObj.tabId = selectedTab?._id || parentData?.tabId;
        insertObj._id = updatedarr?.[0]?._id;
      }
      // Add tabSequence if it exists in selectedTab or getSelectedTabData
      if (selectedTab?.sequence !== undefined) {
        insertObj.tabSequence = selectedTab.sequence;
      } else if (getSelectedTabData?.sequence !== undefined) {
        insertObj.tabSequence = getSelectedTabData.sequence;
      }
      const res = await dispatch(action.addColumnsToProductCpCard(insertObj, t));
      if (res.code === 200 && !insertObj._id) {
        const storageKey = `selectedColumns_${id}`;
        const prevSelectedIds = JSON.parse(localStorage.getItem(storageKey)) || [];
        if (Array.isArray(res?.data)) {
          const newAddedIds = res?.data?.map((item) => item._id) || [];
          const updatedSelectedIds = Array.from(new Set([...prevSelectedIds, ...newAddedIds]));
          localStorage.setItem(storageKey, JSON.stringify(updatedSelectedIds));
        }
      }
      setStatusChaning(false);
      handleClose();

      setModalState((oldState) => ({ ...oldState, loading: false }));

      return true;
    }
    toasterMsg(t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.ADD_UNIQUE_COLUMS'), 'danger');
    setModalState((oldState) => ({ ...oldState, loading: false }));
  };

  const handleSubmit = async () => {
    const array = cloneDeep(modalState.cards);
    const validated = await checkValidation(array);
    if (!validated) {
      await addUpdateColumn();
      dispatch(systemMasterAction.clearLicenseData());
      dispatch(systemMasterAction.clearLikenessData());
    } else {
      toasterMsg(t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.DETAILS'), 'danger');
    }
  };

  const forColumnSequence = (i) => {
    return getSelectedTabData?.columns?.length + i;
  };

  const validateFields = {
    common: ['name', 'columnType', 'manualType'],
    source: ['location', 'output', 'subLocation', 'locationType', 'locationPlacement', 'attribute', 'displayFormat', 'pom'],
    manual: ['manualType', 'options', 'labelColoursOptions', 'status', 'characterLimit'],
  };

  const checkCondition = (col, key, pIndex, fieldError, hasErrors) => {
    validateFields[key].forEach((fieldKey) => {
      if (fieldKey === 'manualType') {
        if (col?.columnType?.name === 'Manual') {
          if (!col[fieldKey]) {
            col.hasError = true;
            hasErrors = true;
            set(fieldError, `[${key}][${pIndex}][${fieldKey}]`, thisFieldIsRequired);
          }
        } else set(fieldError, `[${key}][${pIndex}][${fieldKey}]`, '');
      } else if (!col[fieldKey] || (fieldKey === 'name' && col[fieldKey]?.trim()?.length === 0)) {
        col.hasError = true;
        hasErrors = true;
        set(fieldError, `[${key}][${pIndex}][${fieldKey}]`, thisFieldIsRequired);
      } else {
        set(fieldError, `[${key}][${pIndex}][${fieldKey}]`, '');
      }
    });
    return { fieldError, hasErrors, col };
  };

  const checkValidation = async (array) => {
    let fieldError = {};
    const copyState = array;
    let hasErrors = false;
    const updatedState = copyState?.map((col, pindex) => {
      Object.keys(validateFields)?.forEach(function (key) {
        switch (key) {
          case 'common':
            const validateKey = checkCondition(col, key, pindex, fieldError, hasErrors);
            fieldError = validateKey.fieldError;
            hasErrors = validateKey.hasErrors;
            col = validateKey.col;
            break;
          case 'source':
            sourceChanges(col, key, fieldError, pindex);
            break;
          default:
            manualChange(col);
            break;
        }
      });
      return col;
    });
    setModalState((oldState) => ({ ...oldState, cards: updatedState }));
    return updatedState.filter((e) => e.hasError).length > 0;
  };

  const savingForManualItem = (ele) => {
    delete ele?.source;
    !ele?.isColourCodingActive && delete ele?.colourCoding;
    if (['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button'].includes(ele?.manualType?.key)) {
      if (ele?.manualType?.key === 'Dropdown') {
        const defaultOption = ele?.options?.find((opt) => opt?.isDefault === true);
        if (defaultOption) {
          ele.defaultValue = defaultOption._id || defaultOption.name;
        }
      } else if (ele?.manualType?.key === 'Multi_select_Dropdown') {
        const defaultOptions = ele?.options?.filter((opt) => opt?.isDefault === true);
        if (defaultOptions && defaultOptions.length > 0) {
          ele.defaultValue = defaultOptions.map((opt) => opt._id || opt.name);
        }
      }
      delete ele.labelColoursOptions;
      delete ele.statusColoursOptions;
      delete ele.isStatusEditTrue;
      delete ele.colourCoding;
      delete ele.status;
      delete ele.pom;
      delete ele.displayFormat;
      delete ele.characterLimit;
    } else if (ele?.manualType?.key === 'Label') {
      delete ele.options;
      delete ele.colourCoding;
      delete ele.statusColoursOptions;
      delete ele.isStatusEditTrue;
      delete ele.status;
      delete ele.pom;
      delete ele.displayFormat;
      delete ele.characterLimit;
    } else if (ele?.manualType?.key === 'Status') {
      ele.status = ele.statusColoursOptions.find((colSt) => colSt?.colourHexCode === ele?.status?.colourHexCode);
      delete ele.options;
      delete ele.colourCoding;
      delete ele.labelColoursOptions;
      delete ele.isStatusEditTrue;
      delete ele.characterLimit;
      delete ele.pom;
      delete ele.displayFormat;
    } else if (ele?.manualType?.key === 'Textbox') {
      delete ele.status;
      delete ele.options;
      delete ele.colourCoding;
      delete ele.labelColoursOptions;
      delete ele.isStatusEditTrue;
      delete ele.statusColoursOptions;
      delete ele.pom;
      delete ele.displayFormat;
    } else {
      delete ele.options;
      delete ele.labelColoursOptions;
      delete ele.statusColoursOptions;
      delete ele.isStatusEditTrue;
      delete ele.status;
      delete ele.characterLimit;
      delete ele.pom;
      delete ele.displayFormat;
    }
  };

  const elsePart1 = (col) => {
    return (
      (([
        'Product_Core_Information',
        'Product_Information',
        'Supplier_Information',
        'Specifications',
        'Samples',
        'Costing_Information',
        'Completion_Indicator',
      ].includes(col?.source?.location?.name) ||
        (col?.source?.location?.name === 'Purchase_Order' && col?.source?.attribute?.name === 'valueType')) &&
        !col?.source?.subLocation) ||
      ([
        'Product_Core_Information',
        'Product_Information',
        'Supplier_Information',
        'Design_Details',
        'Bill_of_Materials',
        'Testing',
        careUserDocumentInformation,
        'Costing_Information',
        'Specifications',
        'Samples',
        'Purchase_Order',
        'Completion_Indicator',
      ].includes(col?.source?.location?.name) &&
        !col?.source?.attribute) ||
      ((['Design_Details', 'Bill_of_Materials', 'Testing', careUserDocumentInformation].includes(col?.source?.location?.name) ||
        (col?.source?.location?.name === 'Purchase_Order' && col?.source?.attribute?.name === 'all_item')) &&
        !col?.source?.output) ||
      (['Samples'].includes(col?.source?.location?.name) && (!col?.source?.sampleGroupId || !col?.source?.locationType || !col?.source?.locationPlacement)) ||
      (col?.source?.subLocation?.name === 'ecomSpec' && (!col?.source?.pom || !col?.source?.displayFormat))
    );
  };

  const elsePart2 = (col) => {
    return (
      (col?.source?.location?.name === 'Bill_of_Materials' && !col?.source?.locationType) ||
      (col?.source?.location?.name === 'Bill_of_Materials' && col?.source?.locationType?.name !== 'all_item' && !col?.source?.locationPlacement) ||
      !col.source.location ||
      !col.name
    );
  };

  const newValidations = (col) => {
    return (
      (col?.dependentObj?.dependentSwitch && (!col?.dependentObj?.dependentColumn || !col?.dependentObj?.durationValue || !col?.dependentObj?.durationUnit)) ||
      (col?.durationCounterSwitch && !col?.durationlinkedColumnValue) ||
      (col?.CustomNotificationSwitch && col?.customDurations?.find((ele) => !ele?.durationUnit || !ele?.durationValue))
    );
  };

  const sourceChanges = (col, key, fieldError, pindex) => {
    let error = false;
    if (col?.columnType?.name === 'Source' || col?.columnType === 'source') {
      validateFields[key]?.forEach((fieldKey) => {
        if (!col?.name?.trim().length) {
          col.hasError = true;
          error = true;
          set(fieldError, `[${key}][${pindex}][${fieldKey}]`, thisFieldIsRequired);
        } else if (elsePart1(col) || elsePart2(col) || newValidations(col)) {
          if (!col[fieldKey]) {
            col.hasError = true;
            error = true;
            set(fieldError, `[${key}][${pindex}][${fieldKey}]`, thisFieldIsRequired);
          } else {
            col.hasError = false;
            set(fieldError, `[${key}][${pindex}][${fieldKey}]`, '');
          }
        } else {
          col.hasError = false;
          set(fieldError, `[${key}][${pindex}][${fieldKey}]`, '');
        }
      });
    }
    return error;
  };

  const manualChange = (col) => {
    let error = false;
    if (col?.columnType?.name === 'Manual') {
      if (
        (['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button'].includes(col?.manualType?.key) &&
          col?.options?.filter((e) => isEmpty(e?.name)).length > 0) ||
        (col?.manualType?.key === 'Label' && col?.labelColoursOptions?.filter((e) => e?.isLabelColourChecked).length === 0) ||
        (col?.manualType?.key === 'Status' && !col?.status) ||
        (col?.manualType?.key === 'Textbox' && !col?.characterLimit) ||
        newValidations(col)
      ) {
        error = true;
        col.hasError = true;
      }
    }
    return error;
  };

  const showDateDetails = (ele) => {
    return ele?.columnType?._id === 'source'
      ? ['date_added', 'amended_date'].includes(ele?.source?.output?.name)
      : ele?.manualType?.key === 'Date_picker';
  };

  const disableColourSwitch = (cardEle) => {
    let disable = false;
    if (
      [
        'Product_Core_Information',
        'Product_Information',
        'Supplier_Information',
        'Specifications',
        'Samples',
        'Costing_Information',
        'Completion_Indicator',
      ].includes(cardEle?.source?.location?.name) ||
      (cardEle?.source?.location?.name === 'Bill_of_Materials' && cardEle?.source?.output?.name === 'valueType') ||
      (cardEle?.source?.location?.name === 'Purchase_Order' && cardEle?.source?.attribute?.name === 'valueType') ||
      (cardEle?.source?.location?.name === 'Design_Details' && ['colour', 'status'].includes(cardEle?.source?.output?.name)) ||
      (![
        'Product_Core_Information',
        'Product_Information',
        'Supplier_Information',
        'Design_Details',
        'Bill_of_Materials',
        'Specifications',
        'Testing',
        careUserDocumentInformation,
        'Samples',
        'Costing_Information',
        'Purchase_Order',
        'Completion_Indicator',
      ].includes(cardEle?.source?.location?.name) &&
        cardEle?.source?.output?.name === 'valueType') ||
      [
        'Checkbox',
        'HTML',
        'Dropdown',
        'Label',
        'Text_area',
        'Multi_select_Dropdown',
        'Number_Integer',
        'Number_Decimal',
        'Radio_button',
        'Status',
        'Textbox',
        'Time_picker',
      ].includes(cardEle?.manualType?.key)
    ) {
      disable = true;
    }
    return disable;
  };

  const colourComponent = (cardEle, cardIndex) => {
    return (
      <div className="collapse-card add-bom-accordion">
        <Accordion key={`Column_${cardIndex}`}>
          <Card className="bom-add-card ">
            <Card.Header className="bgcolor-dark rounded-0 ">
              <div className="align-items-center reducing-switch-z-index mr-16">
                <div className="d-inline-flex align-items-center design-switch">
                  <input
                    type="checkbox"
                    className="form-check-input comment-switch-input"
                    id={`colourSwitch_${cardIndex}`}
                    name="colourSwitch"
                    onChange={(e) => forSwitch(e, cardIndex)}
                    checked={cardEle.colorSwitch}
                    disabled={disableColourSwitch(cardEle) || cardEle?.dependentObj?.dependentSwitch}
                  />
                  <label className="switch-text font-heavy align-items-center mt-03" htmlFor={`colourSwitch_${cardIndex}`}>
                    {t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.COLOUR_CODING')}
                  </label>
                </div>
              </div>
              <Accordion.Toggle className="btn-toggle text-decoration-none text-dark" as="button" variant="link">
                <span className="icon-new-down-arrow-icon" />
              </Accordion.Toggle>
            </Card.Header>
            {cardEle?.colorSwitch && (
              <Card.Body>
                <div className="flex-fill">
                  {cardEle?.colourArray?.map((element, index) => {
                    return (
                      <div className="d-flex align-items-center f-14 mb-2" key={`${element?._id}_`}>
                        <div className="status-color-container d-flex">
                          <span className={`${element?.colourType} rount-shape`} />
                        </div>
                        <div className="d-flex flex-wrap align-items-center">
                          <span className="px-2 text-nowrap">{showDateDetails(cardEle) ? constantTextValue(index) : 'if value is '}</span>
                          {['date_added', 'amended_date'].includes(cardEle?.source?.output?.name) || (cardEle?.manualType?.key === 'Date_picker' && index === 1 && 'of')}{' '}
                          {showDateDetails(cardEle) ? (
                            <div className="w-180 px-2 my-1 my-md-0">
                              <Select
                                name="columnName"
                                options={modalState?.dyanmicColumns
                                  ?.filter((coEle) => !cardEle?.colourArray?.some((e) => e?.colourValue === coEle?._id))
                                  ?.map((vl) => {
                                    delete vl?.options;
                                    return vl;
                                  })} // dynamic columns???
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option._id}`}
                                maxMenuHeight={140}
                                menuPlacement="bottom"
                                menuPosition="fixed"
                                isClearable
                                menuShouldBlockScroll
                                menuShouldScrollIntoView
                                value={chcekingFromDynamicArray(modalState?.dyanmicColumns, element?.colourValue) || null}
                                styles={customStylesForOCP}
                                onChange={(e) => onChangeDropDown(e, 'colourValue', cardIndex, index)}
                                placeholder={t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.SELECT_COLUMN')}
                              />
                            </div>
                          ) : (
                            <div className="w-180 px-2 my-1 my-md-0">
                              <Select
                                name="colourValue"
                                options={ColumnValues?.filter((ele) => !cardEle?.colourArray?.map((e) => e?.colourValue)?.includes(ele?._id))}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option._id}`}
                                menuPlacement="bottom"
                                menuPosition="fixed"
                                isClearable
                                menuShouldBlockScroll
                                menuShouldScrollIntoView
                                value={chcekingFromDynamicArray(ColumnValues, element?.colourValue) || null}
                                styles={customStylesForOCP}
                                maxMenuHeight={140}
                                onChange={(e) => onChangeDropDown(e, 'colourValue', cardIndex, index)}
                                placeholder={t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.SELECT_VALUE')}
                              />
                            </div>
                          )}
                          {cardEle?.source?.output?.name === 'date_added' || (cardEle?.manualType?.key === 'Date_picker' && index === 1 && 'by')}{' '}
                          {(element?.colourValue === 'between' || (showDateDetails(cardEle) && index === 1)) && (
                            <div className="d-flex align-items-center ml-1">
                              <input
                                className="form-control text-bordered percentaage-input mx-2"
                                onChange={(e) => changeColourInput(e?.target?.value, 'endPercentage', cardIndex, index)}
                                disabled={!element?.colourValue}
                                value={element?.endPercentage}
                                name="colourStateValue"
                                type="number"
                              />{' '}
                              {showDateDetails(cardEle) ? 'days' : '%'}
                              {cardEle?.hasError && element?.colourValue && !element?.endPercentage && (
                                <span className="error-message">
                                  {t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.PLEASE_ENTER_VALUE')} {/* need to change after confirmation */}
                                </span>
                              )}
                              {!(cardEle?.source?.output?.name === 'date_added' || (cardEle?.manualType?.key === 'Date_picker' && index === 1)) && ' and'}{' '}
                            </div>
                          )}
                          {!showDateDetails(cardEle) && (
                            <>
                              <input
                                className="form-control text-bordered percentaage-input mx-2"
                                onChange={(e) => changeColourInput(e?.target?.value, 'startPercentage', cardIndex, index)}
                                disabled={!element?.colourValue}
                                value={element?.startPercentage}
                                type="number"
                                name="colourStateValue"
                              />{' '}
                              %{' '}
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Card.Body>
            )}
          </Card>
        </Accordion>
      </div>
    );
  };

  const emptyValues = (nullArray, copyState, pIndex) => {
    if (nullArray && !isEmpty(nullArray)) {
      nullArray.forEach((setNull) => {
        if (setNull === 'colourCoading') {
          set(copyState, commonPath(pIndex, 'colorSwitch').COMMON, false);
          set(copyState, commonPath(pIndex, 'colourArray').COMMON, [
            {
              colourValue: '',
              colourType: 'green',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'amber',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'red',
              startPercentage: '',
              endPercentage: '',
            },
          ]);
        } else if (setNull === 'options') {
          set(copyState, commonPath(pIndex, 'options').COMMON, [{ name: '' }]);
        } else if (setNull === 'labelColoursOptions') {
          set(copyState, commonPath(pIndex, 'labelColoursOptions').COMMON, manualLabelColours);
        } else if (setNull === 'statusColoursOptions') {
          set(copyState, commonPath(pIndex, 'statusColoursOptions').COMMON, manualStatusColours);
          set(copyState, commonPath(pIndex, 'status').COMMON, null);
        } else if (setNull === 'dependentObj') {
          set(copyState, commonPath(pIndex, 'dependentObj').COMMON, {
            durationUnit: null,
            durationValue: null,
            dependentColumn: null,
            futureDependent: false,
            dependentSwitch: false,
          });
        } else if (setNull === 'customDurations') {
          set(copyState, commonPath(pIndex, 'customDurations').COMMON, [{ durationUnit: null, durationValue: null, emailNotification: false }]);
          set(copyState, commonPath(pIndex, 'CustomNotificationSwitch').COMMON, false);
        } else if (setNull === 'source') {
          set(copyState, commonPath(pIndex, 'source').COMMON, null);
        } else if (setNull === 'manualType') {
          set(copyState, commonPath(pIndex, 'manualType').COMMON, null);
        } else {
          set(copyState, sourcePath(pIndex, setNull).SOURCE_KEY_PATH, null);
        }
      });
    }
  };

  const outputNullConditions = (getAttribute, getLocation) => {
    return (
      (['first_item', 'last_item'].includes(getAttribute) &&
        ['Product_Core_Information', 'Product_Information', 'Supplier_Information', 'Specifications', 'Samples', 'Costing_Information'].includes(
          getLocation,
        )) ||
      (['Purchase_Order'].includes(getLocation) && getAttribute === 'valueType')
    );
  };

  const outputDateConditon = (getAttribute, getLocation, getLocationId, getLocationType) => {
    return (
      ['first_item', 'last_item'].includes(getAttribute) &&
      (['Design_Details', 'Testing', careUserDocumentInformation].includes(getLocation) ||
        getLocationId === 12 ||
        (['Bill_of_Materials'].includes(getLocation) && getLocationType !== 'all_item') ||
        (['Bill_of_Materials'].includes(getLocation) && getLocationType === 'all_item' && ['first_item', 'last_item'].includes(getAttribute)))
    );
  };

  const setAttrinuteToValue = (getLocation, getLocationPlacment) => {
    return (
      ['Product_Core_Information', 'Product_Information', 'Supplier_Information', 'Specifications', 'Costing_Information', 'Completion_Indicator'].includes(
        getLocation,
      ) ||
      (getLocation === 'Samples' && ['earliest', 'mostRecent'].includes(getLocationPlacment))
    );
  };

  const parentEmptyValue = (parentNullArray, copyState, pIndex) => {
    if (parentNullArray && !isEmpty(parentNullArray)) {
      parentNullArray.forEach((parentVariable) => {
        set(copyState, sourcePath(pIndex, parentVariable), null);
      });
    }
  };

  const handleChange = async (value, path, pIndex, nullArray, parentNullArray) => {
    const copyState = cloneDeep(modalState?.cards);
    set(copyState, path, value);
    copyState[pIndex].hasError = false; // very important

    if (isExactMatch(path, 'assignee')) {
      const assigneeArray = Array.isArray(value) ? value : [];
      if (assigneeArray.length === 0 && copyState[pIndex].isEditableAssignee) {
        set(copyState, commonPath(pIndex, 'isEditableAssignee').COMMON, false);
      }
    }

    if (value?._id === 4) {
      const ecomValues = await dispatch(devOrderAction.getEcommSpec('eCommSpec'));
      if (ecomValues?.isActive) {
        await dispatch(systemMasterAction.getMeasurementDetails({ isActive: true }));
      }
    }
    const bomTypeId = get(copyState, sourcePath(pIndex, 'locationType').SOURCE_KEY_PATH)?.name;
    const isBOMLocation = get(copyState, sourcePath(pIndex, 'location').SOURCE_KEY_PATH)?.name === 'Bill_of_Materials';
    if (loggedInUserId && isBOMLocation && bomTypeId && bomTypeId !== 'all_item') {
      await dispatch(
        systemMasterAction.getBomCustomAttributes({
          bomTypeId,
          loggedInUserId,
          isActive: true,
        }),
      );
    }
    emptyValues(nullArray, copyState, pIndex);
    parentEmptyValue(parentNullArray, copyState, pIndex);

    const getLocation = get(copyState, sourcePath(pIndex, 'location').SOURCE_KEY_PATH)?.name;

    const getLocationId = get(copyState, sourcePath(pIndex, 'location').SOURCE_KEY_PATH)?._id;

    const getLocationPlacment = get(copyState, sourcePath(pIndex, 'locationPlacement').SOURCE_KEY_PATH)?.name;

    const getLocationType = get(copyState, sourcePath(pIndex, 'locationType').SOURCE_KEY_PATH)?.name;

    const getAttribute = get(copyState, sourcePath(pIndex, 'attribute').SOURCE_KEY_PATH)?.name;
    if (setAttrinuteToValue(getLocation, getLocationPlacment)) {
      set(copyState, sourcePath(pIndex, 'attribute').SOURCE_KEY_PATH, {
        label: 'Value',
        name: 'valueType',
      });
    }
    if (path.includes('isStatusEditTrue')) {
      setStatusChaning(true);
    }
    if (path.includes('statusColoursOptions') && statusChaning) {
      set(copyState, commonPath(pIndex, 'status').COMMON, null);
    }
    if (isExactMatch(path, 'attribute')) {
      if (outputNullConditions(getAttribute, getLocation)) {
        set(copyState, sourcePath(pIndex, 'output').SOURCE_KEY_PATH, null);
      } else if (['Bill_of_Materials', 'Testing', careUserDocumentInformation].includes(getLocation) && getAttribute === 'all_item') {
        set(copyState, sourcePath(pIndex, 'output').SOURCE_KEY_PATH, {
          label: 'Percentage of Approval',
          name: 'percentage_of_approval',
        });
      } else if (outputDateConditon(getAttribute, getLocation, getLocationId, getLocationType)) {
        set(copyState, sourcePath(pIndex, 'output').SOURCE_KEY_PATH, {
          label: 'Date Added',
          name: 'date_added',
        });
      } else if (['Purchase_Order'].includes(getLocation) && getAttribute === 'all_item') {
        set(copyState, sourcePath(pIndex, 'output').SOURCE_KEY_PATH, {
          label: 'Percentage of Confirmed',
          name: 'completion_percentage',
        });
      }
    }
    setModalState((prevState) => ({ ...prevState, cards: copyState }));
  };

  const setSubLocationArr = (ele) => {
    const locationId = ele?.source?.location?._id;
    let subLocationArr = cloneDeep(PCPSublocationList?.find((val) => val?.locationId === locationId) || {});
    if (!subLocationArr?.subLocations) {
      const findLocation = locationOptions.find((loc) => loc?.name === ele?.source?.location?.name);
      subLocationArr = cloneDeep(PCPSublocationList?.find((val) => val?.locationId === findLocation?._id) || {});
    }
    let manipulatedDynamicColumns = [];
    const mcColumn = filterCustomAttributesDropdownAndTextType(customAttributeDetail);
    manipulatedDynamicColumns = [];
    mcColumn?.forEach((dyCol) => {
      if (dyCol.isActive) {
        manipulatedDynamicColumns.push({
          label: dyCol?.keyName,
          name: dyCol?._id,
          type: 'string',
        });
      }
    });
    const sampleTrackingArr = sampleTrackingDates?.map((dyCol) => {
      return {
        label: dyCol?.name,
        name: dyCol?._id,
        type: 'date',
      };
    });
    const bomSourceCustomAttributeOptions = Array.isArray(bomSourceCustomAttribute)
      ? bomSourceCustomAttribute.map((dyCol) => {
          return {
            ...dyCol,
            label: dyCol?.keyName,
            name: dyCol?._id,
            type: 'string',
          };
        })
      : [];
    if (ele?.source?.location?.name === 'Product_Information') {
      subLocationArr.subLocations = concat(subLocationArr?.subLocations, manipulatedDynamicColumns);
    }

    if (ele?.source?.location?.name === 'Specifications') {
      subLocationArr.subLocations = concat(subLocationArr?.subLocations);
    }
    if (ele?.source?.location?.name === 'Samples') {
      subLocationArr.subLocations = concat(subLocationArr?.subLocations, sampleTrackingArr);
    }
    if (ele?.source?.location?.name === 'Bill_of_Materials') {
      subLocationArr.subLocations = concat(subLocationArr?.subLocations, bomSourceCustomAttributeOptions);
    }
    // Conditionally include/exclude Sub Brand for Product (locationId: 11) based on access
    if (
      subBrandAccess &&
      ele?.source?.location &&
      (ele?.source?.location?._id === 11 ||
        (ele?.source?.location?._id == null && locationOptions?.find((loc) => loc?.name === ele?.source?.location?.name)?._id === 11)) &&
      Array.isArray(subLocationArr?.subLocations)
    ) {
      subLocationArr.subLocations = concat(subLocationArr.subLocations, [{ label: 'Sub Brand', name: 'subBrand', type: 'string' }]);
    }
    return subLocationArr;
  };

  const viewManualType = (ele) => {
    return ['manual'].includes(ele?.columnType?._id);
  };
  const viewSourceType = (ele) => {
    return ['source'].includes(ele?.columnType?._id);
  };

  const setPlacementForLocation = (data) => {
    if (['Bill_of_Materials'].includes(data?.source?.location?.name)) {
      const selectedBomTypeId = data?.source?.locationType?.name;
      if (!selectedBomTypeId || selectedBomTypeId === 'all_item') {
        return placement_master?.map((val) => ({ name: val?._id, label: val?.name })) ?? [];
      }
      const filteredPlacementMasters = placement_master?.filter((val) => Array.isArray(val?.bomType) && val?.bomType?.includes(selectedBomTypeId)) ?? [];
      return filteredPlacementMasters.map((val) => ({ name: val?._id, label: val?.name }));
    }
    return customSectionPlacementArry;
  };

  const setOptionsForAttribute = (ele) => {
    if (
      [
        'Product_Core_Information',
        'Product_Information',
        'Supplier_Information',
        'Specifications',
        'Samples',
        'Costing_Information',
        'Completion_Indicator',
      ].includes(ele?.source?.location?.name)
    ) {
      return [...productCpAttributeList.filter((attributeElement) => ['valueType'].includes(attributeElement?.name))];
    }
    if (ele?.source?.location?.name === 'Purchase_Order') {
      return [...productCpAttributeList.filter((attributeElement) => ['all_item', 'valueType'].includes(attributeElement?.name))];
    }
    if (ele?.source?.location?.name === 'Bill_of_Materials') {
      return [...productCpAttributeList.filter((attributeElement) => attributeElement?.name !== 'valueType')];
    }
    if (['Design_Details'].includes(ele?.source?.location?.name)) {
      return [...productCpAttributeList.filter((attributeElement) => ['first_item', 'last_item'].includes(attributeElement?.name))];
    }
    if (['Testing', careUserDocumentInformation].includes(ele?.source?.location?.name)) {
      return [...productCpAttributeList.filter((attributeElement) => !['valueType'].includes(attributeElement?.name))];
      // } else if (ele?.source?.location?.name === "Custom_Section") {
    }
    return productCpAttributeList;
  };

  const setOptionsForBomOutput = (ele) => {
    if (
      ele?.source?.location?.name === 'Bill_of_Materials' &&
      ele?.source?.locationType?.name !== 'all_item' &&
      ['first_item', 'last_item'].includes(ele?.source?.attribute?.name)
    ) {
      return prouctBomOutComeList.filter((ele) => ele.name !== 'percentage_of_approval');
    }
    if (
      ele?.source?.location?.name === 'Bill_of_Materials' &&
      ele?.source?.locationType?.name === 'all_item' &&
      ['first_item', 'last_item'].includes(ele?.source?.attribute?.name)
    ) {
      return prouctBomOutComeList.filter((ele) => ele.name === 'date_added');
    }
    if (ele?.source?.location?.name === 'Bill_of_Materials' && ele?.source?.attribute?.name === 'all_item') {
      return prouctBomOutComeList.filter((ele) => ele.name === 'percentage_of_approval');
    }
    return prouctCustmSectionOutComeList;
  };

  const testingOutputList = (ele) => {
    return productCpoutComeList.filter((outputItem) =>
      ['first_item', 'last_item'].includes(ele?.source?.attribute?.name)
        ? ['date_added'].includes(outputItem?.name)
        : outputItem?.name === 'percentage_of_approval',
    );
  };

  const setOptionsForOutput = (ele) => {
    if (['Testing', careUserDocumentInformation].includes(ele?.source?.location?.name)) {
      return [...testingOutputList(ele)];
    }
    if (ele?.source?.location?.name === 'Design_Details') {
      return [
        ...productCpoutComeList.filter((outputItem) => ['date_added'].includes(outputItem?.name)),
        { label: 'Status Date', name: 'status_date' },
        { label: 'Amended Date', name: 'amended_date' },
        { label: 'Colour', name: 'colour' },
        { label: 'Status', name: 'status' },
      ];
    }
    if (ele?.source?.location?.name === 'Purchase_Order') {
      return [...poProductoutComeList.filter((outputItem) => outputItem?.name === 'completion_percentage')];
    }
    if (ele?.source?.location?.name === 'Bill_of_Materials') {
      if (ele?.source?.locationType?.name !== 'all_item' && ['first_item', 'last_item'].includes(ele?.source?.attribute?.name)) {
        return [...productCpoutComeList.filter((outputItem) => ['date_added'].includes(outputItem?.name))];
      }
      return ['first_item', 'last_item'].includes(ele?.source?.attribute?.name)
        ? [...productCpoutComeList.filter((outputItem) => ['date_added'].includes(outputItem?.name))]
        : [...productCpoutComeList.filter((outputItem) => outputItem?.name === 'percentage_of_approval')];
    }
    return productCpoutComeList;
  };

  const manualOptions = (cardEle, cardIndex) => {
    return (
      viewManualType(cardEle) && (
        <ManualColumnSection modalState={modalState} setModalState={setModalState} cardEle={cardEle} cardIndex={cardIndex} handleChange={handleChange} />
      )
    );
  };

  const sourceOptions = (cardEle, cardIndex) => {
    return (
      viewSourceType(cardEle) && (
        <SourceColumnSection
          cardEle={cardEle}
          cardIndex={cardIndex}
          handleChange={handleChange}
          modalState={modalState}
          setSubLocationArr={setSubLocationArr}
          setOptionsForAttribute={setOptionsForAttribute}
          setOptionsForOutput={setOptionsForOutput}
          setOptionsForBomOutput={setOptionsForBomOutput}
          locationOptions={locationOptions}
          setPlacementForLocation={setPlacementForLocation}
          measurmentMaster={measurement_master}
          bomTypes={bomTypes}
          sampleTypeGroupList={sampleTypeGroupList}
        />
      )
    );
  };

  const whenNoParentSupplier = (cardEle) => {
    return cardEle?.isVisibleToSupplier && isEmpty(parentData?.suppliers)
      ? [...modalState.asigneeList, ...supplierList.filter((ele) => ele.accountVerified)]
      : modalState.asigneeList;
  };

  const assigneListForColumn = (cardEle) => {
    return cardEle?.isVisibleToSupplier && !isEmpty(parentData?.suppliers)
      ? [...modalState.asigneeList, ...supplierList.filter((ele) => ele.accountVerified && parentData?.suppliers?.includes(ele._id))]
      : whenNoParentSupplier(cardEle);
  };

  return (
    <Modal
      className="common-custom-modal modal-medium"
      aria-labelledby="contained-modal-title-vcenter"
      show={parentData?.showColumnModal}
      onHide={() => {
        setStatusChaning(false);
        handleClose();
      }}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">{`${colEditData ? t('COMMON_LABEL.EDIT') : t('COMMON_LABEL.ADD')} ${t('COMMON_LABEL.NEW')} ${
          colEditData ? t('COMMON_LABEL.COLUMNS') : t('COMMON_LABEL.COLUMN')
        }`}</Modal.Title>
        <div className="action-icons">
          <button
            type="button"
            className="btn p-0"
            aria-label="Close"
            onClick={() => {
              setStatusChaning(false);
              handleClose();
            }}
          >
            <span className="icon-close f-20 cursor-pointer" />
          </button>
        </div>
      </Modal.Header>
      <Modal.Body className="p-0">
        {modalState.loading ? (
          <Loader />
        ) : (
          <>
            <div className="cp-column-section">
              {modalState?.cards?.map((cardEle, cardIndex) => {
                return (
                  <div key={cardEle?._id} className="d-flex ">
                    <Card className="flex-fill border-none">
                      <Row className="">
                        <Col lg={12}>
                          <div className="common-input-control">
                            <p className="field-name">
                              {t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.COLUMN_NAME')}
                              <span className="asterisk">*</span>
                            </p>
                            <input
                              type="text"
                              value={cardEle?.name}
                              maxLength={50}
                              placeholder={t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.ENTER_COLUMN_NAME')}
                              onChange={(e) => handleChange(e?.target?.value, commonPath(cardIndex, 'name').COMMON, cardIndex)}
                              className="form-control"
                            />
                            {cardEle.hasError && !cardEle?.name?.trim().length && (
                              <span className="error-message d-block">{t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.NAME_IS_REQUIRED')}</span>
                            )}
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div>
                            <p className="asterisk-req f-14 mb-0">
                              {t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.VISIBLE_SUPLIER')} <span>*</span>
                            </p>
                            <div className="d-flex mt-16 align-items-center">
                              <p className="custom-radio">
                                <input
                                  type="radio"
                                  id={`no_${cardIndex}`}
                                  name={`no_${cardIndex}`}
                                  value={cardEle?.isVisibleToSupplier}
                                  checked={!cardEle?.isVisibleToSupplier}
                                  onChange={() => handleChange(false, commonPath(cardIndex, 'isVisibleToSupplier').COMMON, cardIndex)}
                                />
                                <label htmlFor={`no_${cardIndex}`}>{t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.NO')}</label>
                              </p>
                              <p className="custom-radio ml-4">
                                <input
                                  type="radio"
                                  id={`yes_${cardIndex}`}
                                  name={`yes_${cardIndex}`}
                                  value={cardEle?.isVisibleToSupplier}
                                  checked={cardEle?.isVisibleToSupplier}
                                  onChange={() => handleChange(true, commonPath(cardIndex, 'isVisibleToSupplier').COMMON, cardIndex)}
                                />
                                <label htmlFor={`yes_${cardIndex}`}>{t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.YES')}</label>
                              </p>
                            </div>
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className="align-items-start">
                            <div className="flex-fill">
                              <NewCommonMultiSelect
                                label={t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.ASSIGNEE')}
                                onChange={(e) => handleChange(e, commonPath(cardIndex, 'assignee').COMMON, cardIndex)}
                                selectedValue={cardEle?.assignee}
                                optionList={assigneListForColumn(cardEle)}
                                selectLabel="name"
                                selectValue="_id"
                              />
                            </div>
                            <CustomTooltip placement="top" tooltipText={t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.EDITABLE_BY_ASSIGNEE_ONLY')}>
                              <div className="common-checkbox size-sm assignee-checkbox">
                                <input
                                  type="checkbox"
                                  id={`isEditableAssignee_${cardIndex}`}
                                  checked={cardEle?.isEditableAssignee || false}
                                  onChange={(e) => handleChange(e?.target?.checked, commonPath(cardIndex, 'isEditableAssignee').COMMON, cardIndex)}
                                  disabled={!cardEle?.assignee || (Array.isArray(cardEle?.assignee) && cardEle?.assignee.length === 0)}
                                  className="form-check-input"
                                />
                                <label htmlFor={`isEditableAssignee_${cardIndex}`} className="chklabel" />
                              </div>
                            </CustomTooltip>
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className="common-react-select">
                            <p className="field-name">
                              {t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.COLUMN_TYPE')} <span className="asterisk">*</span>
                            </p>

                            <Select
                              options={columTypeList}
                              value={cardEle?.columnType}
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  commonPath(cardIndex, 'columnType').COMMON,
                                  cardIndex,
                                  [
                                    'source',
                                    'location',
                                    'subLocation',
                                    'attribute',
                                    'output',
                                    'locationType',
                                    'locationPlacement',
                                    'colourCoading',
                                    'options',
                                    'labelColoursOptions',
                                    'status',
                                    'statusColoursOptions',
                                    'characterLimit',
                                    'dependentObj',
                                    'customDurations',
                                    'pom',
                                    'displayFormat',
                                    e?._id === 'source' ? 'manualType' : e?._id,
                                  ],
                                  ['manualType'],
                                )
                              }
                              getOptionLabel={(option) => option?.name}
                              getOptionValue={(option) => option?._id}
                              className="common-select"
                              classNamePrefix="common-select"
                              placeholder={t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.SELECT_COLUMN_TYPE')}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              isClearable
                            />
                            {cardEle.hasError && !cardEle?.columnType && (
                              <span className="error-message"> {t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.COLUMN_TYPE_REQUIRED')}</span>
                            )}
                          </div>
                        </Col>
                        {manualOptions(cardEle, cardIndex)}
                        {sourceOptions(cardEle, cardIndex)}
                        {isDateValueColumn(cardEle) && (
                          <Col lg={12} className="mb-1">
                            <div className="collapse-card flex-fill">
                              <DependentAccordian
                                cardEle={cardEle}
                                cardIndex={cardIndex}
                                handleChange={handleChange}
                                modalState={modalState}
                                addEditAccess={addEditAccess}
                              />
                            </div>
                          </Col>
                        )}
                        {isDateValueColumn(cardEle) && (
                          <Col lg={12} className="mb-1">
                            <div className="collapse-card flex-fill">
                              <DurationCounter
                                cardEle={cardEle}
                                cardIndex={cardIndex}
                                handleChange={handleChange}
                                modalState={modalState}
                                addEditAccess={addEditAccess}
                              />
                            </div>
                          </Col>
                        )}
                        {isDateValueColumn(cardEle) && (
                          <Col lg={12} className="mb-1">
                            <div className="collapse-card flex-fill">
                              <CustomNotification cardEle={cardEle} cardIndex={cardIndex} handleChange={handleChange} addEditAccess={addEditAccess} />
                            </div>
                          </Col>
                        )}
                        {cardEle?.columnType && !(disableColourSwitch(cardEle) || cardEle?.dependentObj?.dependentSwitch) && (
                          <Col lg={12} className="mb-1">
                            <div className="collapse-card flex-fill"> {colourComponent(cardEle, cardIndex)}</div>
                          </Col>
                        )}
                        <Col lg={12} className="mb-1">
                          <div>
                            <div className="d-flex mt-16 align-items-center">
                              <p className="custom-radio">
                                <input
                                  type="radio"
                                  id={`optionalField_${cardIndex}`}
                                  name={`optionalField_${cardIndex}`}
                                  checked={!cardEle?.isRequired}
                                  onChange={(e) => handleChange(!e?.target?.checked, commonPath(cardIndex, 'isRequired').COMMON, cardIndex)}
                                />
                                <label htmlFor={`optionalField_${cardIndex}`}>{t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.OPTIONAL_FIELD')}</label>
                              </p>
                              <p className="custom-radio ml-4">
                                <input
                                  type="radio"
                                  id={`requiredField_${cardIndex}`}
                                  name={`requiredField_${cardIndex}`}
                                  checked={cardEle?.isRequired}
                                  onChange={(e) => handleChange(e?.target?.checked, commonPath(cardIndex, 'isRequired').COMMON, cardIndex)}
                                />
                                <label htmlFor={`requiredField_${cardIndex}`}>{t('PRODUCTCP.MODALS.ADD_EDIT_COLUMNS.REQUIRED_FIELD')}</label>
                              </p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Card>

                    {modalState.cards?.length - 1 === cardIndex && !colEditData && addEditAccess && (
                      <div className="btn-outline-container">
                        <button type="button" className="btn mb-16 btn-outline sm" onClick={addCard} aria-label="add">
                          <i className="icon-Add f-20" />
                        </button>
                      </div>
                    )}
                    {modalState.cards?.length > 1 && (
                      <div className="btn-outline-container">
                        <button type="button" className="btn mb-16 btn-outline sm" onClick={() => deleteCard(cardIndex)} aria-label="delete">
                          <i className="icon-delete f-16" />
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="common-model-footer mt-4">
              <button type="button" onClick={handleSubmit} className="btn p-1">
                {colEditData ? (
                  <CustomTooltip placement="top" tooltipText={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.UPDATE')}>
                    <span className="icon-Tick-1 f-24" />
                  </CustomTooltip>
                ) : (
                  <CustomTooltip placement="top" tooltipText={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.ADD')}>
                    <span className="icon-Tick-1 f-24" />
                  </CustomTooltip>
                )}
              </button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default AddEditColumn;
